export default "__VITE_ASSET__CDt6Ujf6__"